module.exports = __webpack_public_path__ + "img/logo_de.93bd03c.svg";